export const app_path = '/app';

export const paths = {
    index: '/',
    confirm_account: '/confirm-account/:unique',
    user_homepage: '/user-homepage',
    auth: {
        login: '/login',
        register: '/register',
        forgotPassword: '/forgot-password',
        resetPassword: '/reset-password/:unique',
    },
    profile: '/profile',
    organisation: '/organisation',
    customization: '/customization',
    pomodoro: '/pomodoro',
    worked_hours: '/worked_hours',
    report: '/report',
    projects_dashboard: '/projects-dashboard',
    archives: '/archives',
    settings: '/settings',
    settings_profile: '/settings/profile',
    settings_projects_dashboard: '/settings/projects-dashboard',
    settings_organisation: '/settings/organisation',
    settings_customization: '/settings/customization',
    settings_pomodoro: '/settings/pomodoro',
    settings_worked_hours: '/settings/worked-hours',
    settings_report: '/settings/report',
    settings_members: '/settings/members',
    settings_visibility_reporting: '/settings/visibility-reporting',
    settings_projects: '/settings/projects',
    settings_program: '/settings/program',
    settings_timeoff: '/settings/time-off'
};

export function baseUrl(path) {
    return `/${path}`;
}

export function appUrl(path) {
    return `/${app_path}/${path}`;
}
